import {request} from './HttpClient';

export default class MarketSearch {
	constructor(app) {
		this.app = app;

		this.searchInput = document.querySelector('.js-market-search-input');
		this.searchBtn = document.querySelector('.js-market-search-btn');
		this.searchResult = document.querySelector('.js-market-search-results');

		if (!this.searchInput || !this.searchBtn || !this.searchResult) return;
		this.bindEvents();
	}

	bindEvents() {
		const self = this;
		self.searchInput.addEventListener('input', self.search.bind(self));

		// enable manual input
		document.addEventListener('click', e => {
			if (!e.target.classList.contains('js-show-market-form')) return;
			e.preventDefault();
			document.querySelector('.js-market-form').classList.add('is-active');
			self.writeValues('', '', '', '', '', true);
		});

		// seach button clicked
		document.querySelector('.js-market-search-btn').addEventListener('click', e => {
			e.preventDefault();
			self.search.bind(self)(e);
		});

		// item (suggestion) selected
		document.addEventListener('click', e => {
			const item = e.target.closest('.js-constructionmarket-item');
			if (!item) return;

			let skel = JSON.parse(item.dataset.skel);
			let active = item.classList.contains('is-active');

			document.querySelectorAll('.js-constructionmarket-item')
				.forEach(elem => elem.classList.remove('is-active'));

			self.writeValues(
				active ? '' : skel['name'],
				active ? '' : skel['street'],
				active ? '' : skel['city'],
				active ? '' : skel['zip'],
				active ? '' : skel['key'],
				!active
			);

			if (!active) {
				item.classList.add('is-active');
				document.querySelector('.js-market-form').classList.add('is-active');
			}
		})
	}

	writeValues(name, street, city, zipCode, key, readOnly) {
		const markt_name = document.querySelector('#ignt-id-markt_name');
		markt_name.value = name;
		markt_name.readOnly = readOnly;
		const markt_street = document.querySelector('#ignt-id-markt_street');
		markt_street.value = street;
		markt_street.readOnly = readOnly;
		const markt_city = document.querySelector('#ignt-id-markt_city');
		markt_city.value = city;
		markt_city.readOnly = readOnly;
		const markt_zipcode = document.querySelector('#ignt-id-markt_zipcode');
		markt_zipcode.value = zipCode;
		const markt_rel = document.querySelector('#rel-dest-markt');
		markt_rel.value = key;
	}

	search(e) {
		const self = this;
		request('/constructionmarket/sqllist', {
			params: {
				'search': self.searchInput.value,
				'limit': 10,
				'orderby': 'name',
				'orderdir': '1',
				'searchMethod': 'incoherent',
			},
		})
			.then(response => response.text())
			.then(response => {
				self.searchResult.innerHTML = response;
			});
	}
}
